const doc = [({"zh_cn":({"buttonCamp":({"addRoom":"添加包裹", "backToHotel":"返回区分预订页", "backToRoomList":"返回部门列表", "removeRoom":"删除包裹", "roomDetail":"包裹详情"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;